export default "__VITE_ASSET__CoAs6Crf__"